import React from "react";
import styled from "styled-components";
import { Task } from "src/types/tasks";
import { TaskSummary } from "./TaskSummary";
import { TaskCart } from "./TaskCart";
import { useResizeObserver } from "src/hooks/useResizeObserver";

interface TaskSidebarProps {
  selectedTasks: Task[];
}

export const TaskSidebar: React.FC<TaskSidebarProps> = ({ selectedTasks }) => {
  const width = useResizeObserver();

  return (
    <SidebarContainer>
      {width > 768 ? <TaskSummary selectedTasks={selectedTasks} /> : null}
      <TaskCart selectedTasks={selectedTasks} />
    </SidebarContainer>
  );
};

const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
  background-color: #dff9ff;
`;
